/**
 * `t.rich` renderer for the `<accent>` highlight in homepage section headings:
 * the teal phrase, colour only. Shared by arm A and arm B's strips.
 *
 * @param {import("react").ReactNode} chunks - the tagged phrase.
 */
export const accent = (chunks) => <span className="figma-a__accent">{chunks}</span>;
